import type { FC } from 'react';

import { Typography } from '@mui/material';

import { StickyDashedLine } from '@pages/networking/Network/components/StickyLine/StickyLine.style';

import { DottedTitleStyled } from './DottedTitle.style';

import type { TypographyOwnProps } from '@mui/material';

interface Props {
  title: string;
  titleEndIcon?: JSX.Element;
  titleVariant?: TypographyOwnProps['variant'];
}

const DottedTitle: FC<Props> = ({ title, titleEndIcon, titleVariant }) => {
  return (
    <DottedTitleStyled>
      <Typography
        variant={titleVariant || 's2'}
        color={(theme) => theme.palette.case.neutral.n800}
        sx={{
          mr: '16px',
        }}
      >
        {title}
        {titleEndIcon}
      </Typography>

      <StickyDashedLine variantBorder="solid" />
    </DottedTitleStyled>
  );
};

export default DottedTitle;
